import { memo, useEffect, useMemo, useState } from 'react';
import { Stack, Button, Menu, MenuItem, FormControl, InputLabel, Select } from '@mui/material';
import { groupBy, uniq } from 'lodash';
import PDFViewer from '../../PDFViewer';

const Documents = ({ documentList }: any) => {
  const [primaryAnchorEl, setPrimaryAnchorElement] = useState<any>();
  const [selectedSubmission, setSelectedSubmission] = useState<any>('');
  const [selectedDocumentCategory, setSelectDocumentCategory] = useState<any>('');
  const [selectedDocument, setSelectDocument] = useState<any>({});

  useEffect(() => {
    // useEffect to set initial values for selectedSubmission, selectedDocumentCategory, and selectedDocument
    // when documentList changes and making 1st document as default under original (ORIG-1) or 1st submission
    const ids = uniq(documentList.map((doc: any) => doc.submission_id));

    const originalSubmission = ids.find((submissionId: any) => submissionId.includes('ORIG-1'));

    const submission = originalSubmission || ids[0];

    setSelectedSubmission(submission);

    const submissionDocuments = documentList.filter((doc: any) => doc.submission_id === submission);

    const categorizedDocuments = groupBy(submissionDocuments, 'category');

    setSelectDocumentCategory(Object.keys(categorizedDocuments)?.[0]);

    const originalDocument = categorizedDocuments?.[Object.keys(categorizedDocuments)?.[0]]?.[0];

    setSelectDocument(originalDocument);
  }, [documentList]);

  const submissionIds: string[] = useMemo(
    () => uniq(documentList.map((doc: any) => doc.submission_id)),
    [documentList]
  );

  const selectedSubmissionDocuments = useMemo(
    () => documentList.filter((doc: any) => doc.submission_id === selectedSubmission),
    [selectedSubmission, documentList]
  );

  const groupedDocuments = useMemo(
    () => groupBy(selectedSubmissionDocuments, 'category'),
    [selectedSubmissionDocuments]
  );

  return (
    <Stack>
      <Stack>
        <FormControl fullWidth size='small'>
          <InputLabel>Submission</InputLabel>
          <Select
            value={selectedSubmission}
            label='Submission'
            onChange={(e: any) => setSelectedSubmission(e.target.value)}>
            {submissionIds.map(submissionId => (
              <MenuItem key={submissionId} value={submissionId}>
                {submissionId}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Stack direction='row' spacing={2}>
          {Object.keys(groupedDocuments).map((category: any) => (
            <Button
              key={category}
              onClick={(e: any) => {
                setSelectDocumentCategory(category);
                setPrimaryAnchorElement(e.currentTarget);
              }}>
              {category}
            </Button>
          ))}
        </Stack>
        <Menu
          anchorEl={primaryAnchorEl}
          open={!!primaryAnchorEl}
          onClose={() => setPrimaryAnchorElement(null)}>
          {groupedDocuments[selectedDocumentCategory]?.map((doc: any) => (
            <MenuItem
              key={doc.s3_path}
              selected={doc.s3_path === selectedDocument.s3_path}
              onClick={() => {
                setSelectDocument(doc);
                setPrimaryAnchorElement(null);
              }}>
              {doc.filename}
            </MenuItem>
          ))}
        </Menu>
      </Stack>
      {selectedDocument && selectedDocument?.s3_path && (
        <Stack height='62vh'>
          <PDFViewer fileUrl={selectedDocument.s3_path} initialPage={0} defaultScale={1} />
        </Stack>
      )}
    </Stack>
  );
};

export default memo(Documents);
